import axios from 'axios'
let qs = require('qs');

let base = 'http://47.104.248.56:8081';

var instance = axios.create({
    headers: {
        // 'content-type': 'application/json',
        'Authorization': ''
    }
});
instance.interceptors.request.use(
    config => {
        config.headers.Authorization = sessionStorage.getItem('Authorization');
        return config
    }, err => {
        return Promise.reject(err)
    });

// 内容管理
// 中心概况-中心简介
export const reqCenterIntroduce = () => { return instance.get(`${base}/centerSituation/centerIntroduceList`) };
//中心概况-服务模式
export const reqServiceScopeList = () => { return instance.get(`${base}/centerSituation/serviceScopeList`) };
//中心概况-组织架构
export const reqOrganizationalStructureList =() => { return instance.get(`${base}/centerSituation/organizationalStructureList`) };
//中心概况-经营宗旨
export const reqManagementAimList =() => { return instance.get(`${base}/centerSituation/managementAimList`)};
//中心概况-平台优势
export const reqPlatformAdvantageList = () => { return instance.get(`${base}/centerSituation/platformAdvantageList`)};


//业务流程-借贷流程
export const reqBorrowProcessList = () => { return instance.get(`${base}/businessSituation/borrowProcessList`)};
//债权转让流程
export const reqDebtTransferProcessList = () => { return instance.get(`${base}/businessSituation/debtTransferProcessList`)};
//股权/基金投资流程
export const reqEcInvestmentProcessList = () => { return instance.get(`${base}/businessSituation/ecInvestmentProcessList`)};
//资料下载
export const reqDataDownloadList = () => { return instance.get(`${base}/businessSituation/dataDownloadList`)};
export const reqFileManagementList = () => { return instance.get(`${base}/fileManagement/fileManagementList`)};

// 政策法规-政策法规
export const reqPoliciesRegulations = (params) => { return instance.get(`${base}/policiesRegulations/policiesRegulationsList`,{ params: params }) };
export const reqPoliciesRegulationsDetailById = params => { return instance.get(`${base}/policiesRegulations/DetailOne`, { params: params }) };
export const reqPervious = params => { return instance.get(`${base}/policiesRegulations/findPervious`, { params: params }) };
export const reqNext = params => { return instance.get(`${base}/policiesRegulations/findNext`, { params: params }) };
//政策法规-借贷知识
export const reqBorrowingKnowledgeList = params => { return instance.get(`${base}/policiesRegulations/BorrowingKnowledgeList`, { params: params }) };
export const reqBorrowingKnowledgeDetailById = params => { return instance.get(`${base}/policiesRegulations/BorrowingKnowledgeDetailOne`, { params: params }) };
export const reqBorrowingKnowledgeDetailPervious = params => { return instance.get(`${base}/policiesRegulations/selectPervious`, { params: params }) };
export const reqBorrowingKnowledgeDetailNext = params => { return instance.get(`${base}/policiesRegulations/selectNext`, { params: params }) };

//股权/基金投资-股权/基金投资介绍
export const reqEcInvestmentIntroductionList = () => { return instance.get(`${base}/otherPage/ecInvestmentIntroductionList`)};
//股权/基金投资项目
export const reqEfInvestmentProjectList = params => { return instance.get(`${base}/referenceCenter/efInvestmentProjectsList`, { params: params }) };
export const reqEfInvestmentProjectsById = params => { return instance.get(`${base}/referenceCenter/efInvestmentProjectsById`, { params: params }) };
export const reqEfInvestmentProjectDetailPervious = params => { return instance.get(`${base}/referenceCenter/selectEfInvestmentProjectDetailPervious`, { params: params }) };
export const reqEfInvestmentProjectDetailNext = params => { return instance.get(`${base}/referenceCenter/selectEfInvestmentProjectDetailNext`, { params: params }) };

//股权/基金投资-成功案例
export const reqSuccessfulCaseList= () => { return instance.get(`${base}/otherPage/successfulCaseList`)};

//其他页面-合作伙伴
export const reqCooperativePartnerList= () => { return instance.get(`${base}/otherPage/cooperativePartnerList`)};
//其他页面-法律申明
export const reqLawStatementList= () => { return instance.get(`${base}/otherPage/lawStatementList`)};
//其他页面-招贤纳士
export const reqRecruitmentList= () => { return instance.get(`${base}/otherPage/recruitmentList`)};
export const reqContactUs= () => { return instance.get(`${base}/otherPage/ContactUsList`)};
// 其他页面-首页统计
export const reqBannerStatistical= () => { return instance.get(`${base}/otherPage/bannerStatistical`)};
// 其他页面-中心问答
export const reqCenterAnswer= () => { return instance.get(`${base}/otherPage/centerAnswer`)};
// 其他页面-首页伙伴
export const reqHomePagePartner= () => { return instance.get(`${base}/otherPage/homePagePartner`)};

//资讯中心
//通知公告
export const reqNotificationAnnouncementList = params => { return instance.get(`${base}/referenceCenter/notificationAnnouncementList`, { params: params }) };
export const reqNotificationAnnouncementById = params => { return instance.get(`${base}/referenceCenter/notificationAnnouncementById`, { params: params }) };
export const reqNotificationAnnouncementPervious = params => { return instance.get(`${base}/referenceCenter/selectNotificationAnnouncementPervious`, { params: params }) };
export const reqNotificationAnnouncementNext = params => { return instance.get(`${base}/referenceCenter/selectNotificationAnnouncementNext`, { params: params }) };
//中心新闻
export const reqCenterNewsListLIst = params => { return instance.get(`${base}/referenceCenter/centerNewsList`, { params: params }) };
export const reqCenterNewsById = params => { return instance.get(`${base}/referenceCenter/centerNewsById`, { params: params }) };
export const reqCenterNewsPervious = params => { return instance.get(`${base}/referenceCenter/selectCenterNewsPervious`, { params: params }) };
export const reqCenterNewsNext = params => { return instance.get(`${base}/referenceCenter/selectCenterNewsNext`, { params: params }) };
//行业资讯
export const reqIndustryInformationList = params => { return instance.get(`${base}/referenceCenter/industryInformationList`, { params: params }) };
export const reqIndustryInformationById = params => { return instance.get(`${base}/referenceCenter/industryInformationById`, { params: params }) };
export const reqIndustryInformationPervious = params => { return instance.get(`${base}/referenceCenter/selectIndustryInformationPervious`, { params: params }) };
export const reqIndustryInformationNext = params => { return instance.get(`${base}/referenceCenter/selectIndustryInformationNext`, { params: params }) };
//投资快讯
export const reqInvestmentExpressList= params => { return instance.get(`${base}/referenceCenter/investmentExpressList`, { params: params }) };
export const reqInvestmentExpressById= params => { return instance.get(`${base}/referenceCenter/investmentExpressById`, { params: params }) };
export const reqInvestmentExpressPervious= params => { return instance.get(`${base}/referenceCenter/selectInvestmentExpressPervious`, { params: params }) };
export const reqInvestmentExpressNext= params => { return instance.get(`${base}/referenceCenter/selectInvestmentExpressNext`, { params: params }) };
//交流合作
export const reqCommunicationCooperationList = params => { return instance.get(`${base}/referenceCenter/communicationCooperationList`, { params: params }) };
export const reqCommunicationCooperationById = params => { return instance.get(`${base}/referenceCenter/communicationCooperationById`, { params: params }) };
export const reqCommunicationCooperationPervious = params => { return instance.get(`${base}/referenceCenter/selectCommunicationCooperationPervious`, { params: params }) };
export const reqCommunicationCooperationNext = params => { return instance.get(`${base}/referenceCenter/selectCommunicationCooperationNext`, { params: params }) };
//案例展示
export const reqCaseShowList = params => { return instance.get(`${base}/referenceCenter/caseShowList`, { params: params }) };
export const reqCaseShowById = params => { return instance.get(`${base}/referenceCenter/caseShowById`, { params: params }) };
export const reqCaseShowPervious = params => { return instance.get(`${base}/referenceCenter/selectCaseShowPervious`, { params: params }) };
export const reqCaseShowNext = params => { return instance.get(`${base}/referenceCenter/selectCaseShowNext`, { params: params }) };

export const reqGetHotRC = params => { return instance.get(`${base}/referenceCenter/queryHotRC`, { params: params }) };



// WEBPACK FOOTER //
// ./src/api/contentManagement-api.js